import React, { useState } from 'react';
import { Mail } from 'lucide-react';
import { Card } from '../../../components/ui/card';
import { fmtNum } from './kpiUtils';
import { fmtFecha } from './atencionUtils';
import { ColumnasSelector, useColumnas } from './ColumnasSelector';
import { TablaAtencion } from './TablaAtencion';

const COLUMNAS = [
  { key: 'ticket_id', label: 'ID', fija: true, className: 'tabular-nums text-slate-500', render: (t) => `#${t.ticket_id}` },
  { key: 'fecha', label: 'Fecha', className: 'whitespace-nowrap', render: (t) => fmtFecha(t.fecha) },
  { key: 'estado', label: 'Estado' },
  { key: 'grupo', label: 'Grupo', defecto: false },
  { key: 'asunto', label: 'Asunto', className: 'text-slate-700', render: (t) => t.asunto || '—' },
];

// B6: tipos de email (tickets que no son del bot) y listas de Retención MP y Reclamo / Estafa.
export const AtencionTiposEmail = ({ tipos = {} }) => {
  const listas = tipos.listas || {};
  const nombres = Object.keys(listas);
  const [sel, setSel] = useState(nombres[0]);
  const actual = sel || nombres[0];
  const cols = useColumnas('email', COLUMNAS);
  return (
    <Card className="mb-6 p-5 lg:p-6" data-testid="atencion-tipos-email">
      <h2 className="mb-4 flex items-center gap-2 text-base font-semibold text-slate-800"><Mail className="h-4 w-4 text-sky-600" /> Tipos de email</h2>
      <div className="grid gap-6 lg:grid-cols-3">
        <div className="space-y-2">
          {(tipos.conteo || []).map((c) => (
            <div key={c.tipo} className="flex items-center justify-between rounded-lg bg-slate-50 px-3 py-2 text-sm" data-testid={`atencion-email-tipo-${c.tipo}`}>
              <span className="text-slate-700">{c.tipo}</span><span className="font-semibold tabular-nums">{fmtNum(c.total)}</span>
            </div>
          ))}
          {!(tipos.conteo || []).length && <p className="text-sm text-slate-400">Sin emails en el período.</p>}
        </div>
        <div className="lg:col-span-2">
          <div className="mb-3 flex flex-wrap items-center gap-2">
            {nombres.map((n) => (
              <button key={n} type="button" onClick={() => setSel(n)} data-testid={`atencion-email-tab-${n}`}
                className={`rounded-full px-3 py-1 text-xs font-medium transition-colors ${actual === n ? 'bg-sky-600 text-white' : 'bg-slate-100 text-slate-600 hover:bg-slate-200'}`}>
                {n} ({fmtNum((listas[n] || []).length)})
              </button>
            ))}
            <div className="ml-auto"><ColumnasSelector columnas={COLUMNAS} estado={cols} testId="atencion-email-cols" /></div>
          </div>
          {actual && (
            <div data-testid={`atencion-email-lista-${actual}`}>
              <TablaAtencion columnas={COLUMNAS} ver={cols.ver} filas={listas[actual] || []} rowKey={(t) => t.ticket_id}
                vacio="Sin tickets de este tipo en el período." sticky maxH="max-h-[300px]" />
            </div>
          )}
        </div>
      </div>
    </Card>
  );
};
